import type { StewardAttachment } from '@/lib/api'

// Any file type is accepted — IngestNode reads what it can (images/PDF/text) and files the rest
// as-is. Caps keep the inline base64 request sane.
export const MAX_ATTACHMENT_BYTES = 15 * 1024 * 1024 // 15 MB per file
export const MAX_ATTACHMENTS = 8

export interface PendingAttachment extends StewardAttachment {
  size: number
}

/** Read a File as base64 WITHOUT the `data:<mime>;base64,` prefix (the wire shape the API wants). */
export function readFileAsBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      const res = String(reader.result || '')
      const comma = res.indexOf(',')
      resolve(comma >= 0 ? res.slice(comma + 1) : res)
    }
    reader.onerror = () => reject(reader.error || new Error('file read failed'))
    reader.readAsDataURL(file)
  })
}

export async function fileToAttachment(file: File): Promise<PendingAttachment> {
  const data_base64 = await readFileAsBase64(file)
  return {
    filename: file.name || 'file',
    mime: file.type || 'application/octet-stream',
    data_base64,
    size: file.size,
  }
}

/** Pretty byte size for a chip (e.g. "1.2 MB"). */
export function fmtSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}
